import React from 'react';
import {FieldViewProps} from "../../../render/view";

export default function FieldProgress_ViewSmall(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    if (_.isNil(value)) return false;

    return (
        <div className={Classes("ui5-txt-less-important-small", "fl-ac", props.className)}>
            <span className="txt-truncate">{value}%</span>
        </div>
    );
}
